import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D, HandNote, Sticker } from "@/components/Objects3D";

export const About = () => {
  const { c, ui } = useContent();
  return (
    <Section id="about" num="02" chapter={ui.about.chapter} className="bg-ivory">
      <Shape3D shape="flower" size={62} className="absolute left-[4%] bottom-16 opacity-70 hidden md:block" duration={8} />
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <SectionTitle>
              {ui.about.titleA} <span className="italic text-cobalt">{ui.about.titleB}</span>, {ui.about.titleC}
            </SectionTitle>
            <Reveal delay={0.15}>
              <blockquote className="relative mt-10 border-l-4 border-cobalt pl-6 font-serif italic text-xl md:text-2xl leading-relaxed text-choco/85">
                “{c.about.lead}”
                <HandNote className="absolute -top-7 -left-2 rotate-[-6deg] text-lg">{ui.about.note}</HandNote>
              </blockquote>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="mt-10 flex flex-wrap gap-2.5" data-testid="about-values">
                {c.about.values.map((v, i) => (
                  <Sticker key={v} color={i % 2 === 0 ? "bg-powder" : "bg-beige"} rotate={i % 2 === 0 ? "-rotate-2" : "rotate-2"}>
                    {v}
                  </Sticker>
                ))}
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <figure className="tilt-hover mt-12 w-64 bg-white border border-line rounded-xl p-3 shadow-[0_20px_44px_-26px_rgba(51,38,25,0.35)] -rotate-3" data-testid="about-photo">
                <div className="overflow-hidden rounded-lg aspect-[3/4]">
                  <img src="/photos/cafe-evening.jpeg" alt="Sahithi in a café" className="w-full h-full object-cover" loading="lazy" />
                </div>
                <figcaption className="px-1 pt-3 pb-1">
                  <HandNote>{ui.about.photoCaption}</HandNote>
                </figcaption>
              </figure>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-8">
          {c.about.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.08 * i}>
              <p className="text-base md:text-lg leading-relaxed text-cocoa" data-testid={`about-paragraph-${i}`}>
                <span className="font-serif text-2xl text-cobalt mr-2">{String(i + 1).padStart(2, "0")}</span>
                {p}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
};
